// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import iView from 'iview';
import BaiduMap from 'vue-baidu-map'
import 'iview/dist/styles/iview.css';
import router from './router';
import 'jquery'
import './assets/css/media.css';

// 头部组件
import Header from '@/components/cuscom/header.vue'

// 底部组件
import Footer from '@/components/cuscom/footer.vue'

Vue.config.productionTip = false

// 全局自定义组件 - 头部
Vue.component(Header.name, Header)
// 全局自定义组件 - 底部
Vue.component(Footer.name, Footer)

Vue.use(iView);
/* eslint-disable no-new */
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'YOUR_APP_KEY'
})

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js